import { render } from "./PasswordValidation.vue?vue&type=template&id=32451006&scoped=true"
import script from "./PasswordValidation.vue?vue&type=script&lang=js"
export * from "./PasswordValidation.vue?vue&type=script&lang=js"

import "./PasswordValidation.vue?vue&type=style&index=0&id=32451006&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32451006"]])

export default __exports__